export default {
  filter_params: function (params) {
    let pagination = params.with_pagination
      ? params.pagination
        ? `?isPaginated=1&page=${params.pagination.currentPage}&perPage=${params.pagination.perPage}`
        : "?isPaginated=1"
      : "";
    if (params?.url_filter) {
      if (!Object.values(params.url_params).length) {
        return "";
      }
      let url_params = params.url_params;
      let query = !!pagination ? pagination + "&isFilterable=true&" : "?isFilterable=true&";
      let i = 0;
      for (let key in url_params) {
        query += `${key}=${url_params[key]}&`;
        i++;
        i === Object.keys(url_params).length
          ? (query = query.slice(0, -1))
          : null;
      }
      return query;
    } else {
      return pagination;
    }
  },
};
